module.exports = __webpack_public_path__ + "static/img/chartbanner.a7207270.png";